import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import GuidelineImage from "@assets/Hero_Image.png";
// import GuidelineFrame from "@assets/GuidelineFrame.png";

const HeroSection = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  minHeight: 560,
  height: 864,
  display: "flex",
  backgroundImage: `url(${GuidelineImage})`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  [theme.breakpoints.down("md")]: {
    height: "auto",
    minHeight: 480,
  },
}));

export default function UniComply_Guideline() {
  return (
    <HeroSection>
      <Box
        sx={{
          //   position: "relative",
          top: 0, // ✅ stick to top of HeroSection
          left: 0,
          width: "100%", // ✅ stretch across HeroSection
          height: "100px", // adjust height of the frame area
          zIndex: 99,
          background:
            "linear-gradient(180deg, var(--Brand-Colors-color-brand-primary, #0A829D) 0%, rgba(255, 255, 255, 0.00) 100%)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            // gap: "16px",
            mt: 6,
            paddingBottom: "15px",
          }}
        >
          <Typography
            sx={{
              color: "var(--Primary-Color-Palette-900, #033843)",
              fontFamily: "Rethink Sans",
              fontSize: { xs: "28px", sm: "32px", md: "40px" },
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: { xs: "110%", sm: "110%", md: "61.114%" },
              letterSpacing: "-0.4px",
            }}
          >
            Human Guided{" "}
            <Box
              component="span"
              sx={{
                color: "var(--Primary-Color-Palette-500, #0A829D)", // 👈 different color for '+'
              }}
            >
              +
            </Box>{" "}
            AI Accelerated
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "auto",
            maxWidth: { xs: "90%", sm: "500px", md: "500px" },
            padding: "6px 20px 6px 16px",
            alignItems: "center",
            borderRadius: "8px",
            mx: "auto",
            mt: "5px",
            background:
              "linear-gradient(94deg, #30CAD6 -2.59%, var(--Primary-Color-Palette-500, #0A829D) 115.51%)",
          }}
        >
          <Typography
            sx={{
              color: "var(--Primary-Color-Palette-100, #E5F5F8)",
              fontSize: { xs: "18px", sm: "20px", md: "22px" },
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: { xs: "20px", sm: "22px", md: "24px" },
              letterSpacing: "-0.4px",
              textAlign: "center",
            }}
          >
            Compliance for Every Regulation, Every Stakeholder
          </Typography>
        </Box>
      </Box>
      {/* </Container> */}
    </HeroSection>
  );
}
